import { Transacao } from '../../../servicos/transacoes/typeTransacao';

/**
 * Realizado do mês por categoria (cards da tela de Categorias) — extraído do
 * componente sem mudança de comportamento.
 */

// Converte a data da transação (Date, "dd/mm/aaaa" ou ISO) para Date local.
export const dataDaTransacao = (data: Date | string): Date => {
  if (data instanceof Date) return data;
  const texto = String(data);
  if (texto.includes('/')) {
    const [dia, mes, ano] = texto.split('/').map(Number);
    return new Date(ano, mes - 1, dia);
  }
  return new Date(texto);
};

/**
 * Soma o realizado do mês atual por categoria (chave: "categoriaId-tipo"),
 * considerando só transações com categoria e com data a partir de inicioMes.
 * Pagamento de fatura (sem categoria) nunca aparece em nenhuma categoria.
 */
export const realizadoDoMesPorCategoria = (
  transacoes: Transacao[],
  inicioMes: Date
): Map<string, number> => {
  const mapa = new Map<string, number>();
  const inicio = inicioMes.getTime();
  transacoes.forEach((transacao) => {
    if (!transacao.categoriaId) return;
    if (dataDaTransacao(transacao.data).getTime() < inicio) return;
    const chave = `${transacao.categoriaId}-${transacao.tipo}`;
    mapa.set(chave, (mapa.get(chave) || 0) + transacao.valor);
  });
  return mapa;
};
